import { theme } from '@/styles/theme';

export const styles = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    paddingLeft: 2,
    paddingRight: 2,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    overflowX: 'auto',
    paddingTop: 2,
    flexGrow: 1,
  },
  listText: {
    paddingLeft: '12px',
  },
  description: {
    paddingTop: 0.5,
    color: theme.palette.gray.main,
    fontSize: '12px',
  },
  paymentCard: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
  },
  checkButton: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  buttonBox: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  trashIcon: { fontSize: '2.4rem', color: theme.palette.gray.main },
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: 2,
  },
  emptyStateImage: {
    width: '30%',
    paddingBottom: 2,
  },
  titleEmpty: {
    fontSize: 16,
    fontWeight: 600,
  },
  descriptionEmpty: {
    fontSize: 14,
    textAlign: 'center',
  },
};
